import React from "react";
import Project from "../components/Project/Project";
import supportDesk from "../assets/projects/supportDesk.webp";
import bankist from "../assets/projects/bankist.webp";
import forkify from "../assets/projects/forkify.webp";
import houseMarket from "../assets/projects/houseMarket.webp";
import ominiFood from "../assets/projects/ominiFood.webp";
import outdoor from "../assets/projects/outdoor.webp";
import MainButton from "../components/buttons/MainButton";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const data = [
  {
    tour__heading: "outdoor",
    description: "Website for tour operators to showcase their services.",
    detailedDescription:
      "Outdoors is  React based website for tour operators created using advanced vanilla CSS. This is a completely resposive and used fluid desig principles and optimizations.",
    features: [
      "Video as backround.",
      "Navigation only using css.",
      "Images with density switching.",
    ],
    stack: ["Javascript", "HTML", "CSS"],
    tour__img: outdoor,
    youtubeURL: "https://www.youtube.com/embed/evEHKAe0p-0",
    liveURL: "https://pranavmappoli.github.io/OutDoor/",
    githubURL: "https://github.com/pranavmappoli/OutDoor",
  },
  {
    tour__heading: "support desk",
    description:
      "MERN stack based project for create and manage tickets like Jira.",
    detailedDescription:
      "Support Desk is a MERN stack based project for create and manage tickets like Jira. The backend has created with Node JS and front has created with React JS. It supports all CRUD operation and it have a responsive design as well.",
    features: [
      "JWT login",
      "CRUD operation support",
      "Redux toolkit for state management",
    ],
    stack: ["React", "NodeJS", "MongoDB", "Express"],
    tour__img: supportDesk,
    youtubeURL: "https://www.youtube.com/embed/EKRb3bY2Dd0",
    liveURL: "pranavmappoli.github.io/supportdesk",
    githubURL: "https://github.com/pranavmappoli/supportdesk",
  },
  {
    tour__heading: "omini food",
    description: "Omini food is food oriented website developed using vanila.",
    detailedDescription:
      "omini food is a food oriented website used for showcaseing the healthy diet plans. This website is build using technologies like HTML5 and CSS3.",
    features: ["Responsive & optimized design", "Vanila css", "fluid design"],
    stack: ["Javascript", "HTML", "CSS"],
    tour__img: ominiFood,
    youtubeURL: "https://www.youtube.com/embed/rtvZCfT7Ia8",
    liveURL: "https://pranavmappoli.github.io/OmniFood/",
    githubURL: "https://github.com/pranavmappoli/OmniFood",
  },
  {
    tour__heading: "bankist",
    description:
      "Simulate the experience of a banking application with user account.",
    detailedDescription:
      "Bankist is a bank application website where user can sign in to their users account and having somany features like send money, apply loan, close account with a beautiful interface.",
    features: ["MVC architecture", "Vanila javascript", "User login"],
    stack: ["Javascript", "HTML", "CSS"],
    tour__img: bankist,
    youtubeURL: "https://www.youtube.com/embed/qb4k3IiLhoE",
    liveURL: "https://pranavmappoli.github.io/bankist/",
    githubURL: "https://github.com/pranavmappoli/bankist",
  },
  {
    tour__heading: "house market",
    description:
      "Commercial website for house sell and buy with firebase integration",
    detailedDescription:
      "House market is a commercial website for house sell and buy with firebase integration including user registration and user login.",
    features: [
      "Firbase based.",
      "User login and signup.",
      "CRUD operation on user ads.",
    ],
    stack: ["Javascript", "tailwind css", "firebase"],
    tour__img: houseMarket,
    youtubeURL: "https://www.youtube.com/embed/F_Jd7f0YVHA",
    liveURL: "https://pranavmappoli.github.io/house-market/",
    githubURL: "https://github.com/pranavmappoli/house-market",
  },
  {
    tour__heading: "forkify",
    description:
      "Application for food restaurant management including backend integration",
    detailedDescription:
      "Forkify isa a web application for food restaurant management. It helps to find different food items and calculate required food ingrediants required.",
    features: [
      "Integrated with public API",
      "Responsive design",
      "Form handling.",
    ],
    stack: ["Javascript", "HTML", "CSS"],
    tour__img: forkify,
    youtubeURL: "https://www.youtube.com/embed/x1AIe1-o9uA",
    liveURL: "https://forkify-pranavmappoli.netlify.app/",
    githubURL: "https://github.com/pranavmappoli/forkify",
  },
];

function Projects() {
  const [page, setPage] = useState(1);
  const pageOffset = 3;

  const variants = {
    initial: {
      y: "150%",
      opacity: 0.5,
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: "0.5",
        type: "ease-in",
      },
    },
  };
  return (
    <section id="projects">
      <div className="section__title">Projects</div>
      <div className="container flex-col items-center mx-4">
        <AnimatePresence initial={false}>
          <div className="grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full gap-8 lg:gap-2 lg:gap-y-8 place-items-center md:place-items-between">
            {data.slice(0, page * pageOffset).map((item, indx) => (
              <motion.div
                className="flex items-center justify-center"
                initial="initial"
                animate="animate"
                variants={variants}
                key={indx}
              >
                <Project
                  tour__heading={item.tour__heading}
                  description={item.description}
                  detailedDescription={item.detailedDescription}
                  features={item.features}
                  stack={item.stack}
                  tour__img={item.tour__img}
                  youtubeURL={item.youtubeURL}
                  liveURL={item.liveURL}
                  githubURL={item.githubURL}
                ></Project>
              </motion.div>
            ))}
          </div>
        </AnimatePresence>
        {page * pageOffset < data.length && (
          <MainButton
            btn__color="hsl(250, 70%, 96%)"
            btn__bgcolor="hsl(250, 69%, 61%)"
            btn__name="View More"
            btn__callback={() => setPage((prev) => prev + 1)}
          ></MainButton>
        )}
      </div>
    </section>
  );
}

export default Projects;
